import Image from 'next/future/image';
import cn from 'classnames';
import { KEY_METRICS } from './constants';

const KeyMetrics = () => (
  <section className="bg-white">
    <div className="reebelo-container py-10 sm:py-16">
      <div className="text-center">
        <h3 className="text-xl font-bold xl:text-2xl">Key metrics</h3>
        <p>
          Together, we can reduce waste significantly and contribute towards a
          sustainable future.
        </p>
      </div>
      <div className="mt-5 grid grid-cols-1 items-center justify-around gap-5 xxs:mt-10 xxs:grid-cols-2 sm:flex">
        {KEY_METRICS.map((metric) => (
          <div
            className={cn(
              'flex shrink-0 flex-col items-center justify-center text-center',
              { 'hidden md:flex': metric.hideMobile },
            )}
          >
            <div className="flex shrink-0 items-center gap-2">
              <div className="h-7 w-7 shrink-0 lg:h-8 lg:w-8 xl:h-9 xl:w-9">
                <Image
                  src={metric.icon}
                  alt={metric.title}
                  width={100}
                  height={100}
                  className="h-full w-full"
                />
              </div>
              <h4 className="shrink-0 text-xl lg:text-2xl xl:text-3xl">
                {metric.title}
              </h4>
            </div>
            <p className="mt-1 shrink-0">{metric.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default KeyMetrics;
